import { useMemo } from 'react'

import Bowser from 'bowser'
const useBrowserInfo = () => {
    return useMemo(() => Bowser.parse(window.navigator.userAgent), [])
}
export default useBrowserInfo
